<button
  type="button"
  (click)="toggle()"
  [attr.aria-label]="state.ariaLabel | cxTranslate"
  [attr.title]="state.ariaLabel | cxTranslate"
  [attr.aria-pressed]="state.inputType === showState.inputType"
>
  <span aria-hidden="true">
    <cx-icon [type]="state.icon"></cx-icon>
  </span>
</button>
